import { Link } from "react-router-dom";
interface successMsgProps {
  message: string;
}
const SuccessMessage = (props: successMsgProps) => {
  const { message } = props;
  return (
    <div className="wiley-forgotPasswordMSuccessMsgDiv">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M21 6L9 18L3 12" stroke="#008707" strokeWidth="2" />
        </svg>
      </div>
      <div className="msg">
        {message} Please&nbsp;
        <Link to={"https://hub.wiley.com/community/support/"}>
          contact customer support
        </Link>{" "}
        if you require additional assistance.
      </div>
    </div>
  );
};

export default SuccessMessage;
